/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { AdditionalEquipmentTypeFromJSON, AdditionalEquipmentTypeToJSON, ApplicationUserFromJSON, ApplicationUserToJSON, EquipmentStateFromJSON, EquipmentStateToJSON, ProtocolFromJSON, ProtocolToJSON, } from './';
export function AdditionalEquipmentFromJSON(json) {
    return AdditionalEquipmentFromJSONTyped(json, false);
}
export function AdditionalEquipmentFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'createdDate': !exists(json, 'createdDate') ? undefined : (new Date(json['createdDate'])),
        'modifiedDate': !exists(json, 'modifiedDate') ? undefined : (json['modifiedDate'] === null ? null : new Date(json['modifiedDate'])),
        'createdBy': !exists(json, 'createdBy') ? undefined : ApplicationUserFromJSON(json['createdBy']),
        'createdById': !exists(json, 'createdById') ? undefined : json['createdById'],
        'modifiedBy': !exists(json, 'modifiedBy') ? undefined : ApplicationUserFromJSON(json['modifiedBy']),
        'modifiedById': !exists(json, 'modifiedById') ? undefined : json['modifiedById'],
        'name': json['name'],
        'isVisible': !exists(json, 'isVisible') ? undefined : json['isVisible'],
        'carId': !exists(json, 'carId') ? undefined : json['carId'],
        'state': EquipmentStateFromJSON(json['state']),
        'type': AdditionalEquipmentTypeFromJSON(json['type']),
        'protocols': !exists(json, 'protocols') ? undefined : (json['protocols'] === null ? null : json['protocols'].map(ProtocolFromJSON)),
    };
}
export function AdditionalEquipmentToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'createdBy': ApplicationUserToJSON(value.createdBy),
        'modifiedBy': ApplicationUserToJSON(value.modifiedBy),
        'name': value.name,
        'isVisible': value.isVisible,
        'carId': value.carId,
        'state': EquipmentStateToJSON(value.state),
        'type': AdditionalEquipmentTypeToJSON(value.type),
        'protocols': value.protocols === undefined ? undefined : (value.protocols === null ? null : value.protocols.map(ProtocolToJSON)),
    };
}
